import type {ReduxStore} from 'src/reducers';
import type {TypedIntent} from './agentic-ui-event-bus';
import * as React from 'react';
import {useRegisterAgenticUIIntent} from 'src/components/agentic-ui';
import {sendMessage} from './ask-ai-store';
import {setAIPanelOpenEvent} from 'src/action-creators/sense-ai-panel';


export const useHandleAskAiEvents = (reduxStore: ReduxStore) => {
  useRegisterAgenticUIIntent('graceai', 'graceai.selectprompt', (intent) => {
    const prompt = (intent.payload as {prompt: string}).prompt;
    if (prompt) {
      sendMessage(prompt);
    }
  });
  useRegisterAgenticUIIntent('graceai', 'graceai.generatecontent', (_) => {
    reduxStore.dispatch(setAIPanelOpenEvent(true));
  });
};
